import { render } from "./index.vue?vue&type=template&id=2a2f08b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2a2f08b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a2f08b4"

export default script